import { ProductSelectEvent } from '@shopify/events';

// Horizon owns price/media/cart updates. Use its resolved server HTML only to
// update our added context when a shopper chooses a different native size.
(() => {
  if (window.zamooriProductContextInstalled) return;
  window.zamooriProductContextInstalled = true;
  document.addEventListener(ProductSelectEvent.eventName, async (event) => {
    try {
      const section = event.target.closest('.shopify-section');
      const selection = await event.promise;
      if (!selection?.detail?.html) return;
      for (const selector of ['[data-zm-context]', '[data-zm-customer-information]']) {
        for (const context of section?.querySelectorAll(selector) ?? []) {
          const next = [...selection.detail.html.querySelectorAll(selector)]
            .find((item) => item.dataset.sectionId === context.dataset.sectionId &&
              item.dataset.productId === context.dataset.productId &&
              item.dataset.contextRole === context.dataset.contextRole);
          if (next) {
            const replacement = next.cloneNode(true);
            const openKeys = [...context.querySelectorAll('details[open][data-zm-customer-key]')]
              .map((item) => item.dataset.zmCustomerKey);
            for (const detail of replacement.querySelectorAll('details[data-zm-customer-key]')) {
              if (openKeys.includes(detail.dataset.zmCustomerKey)) detail.open = true;
            }
            context.replaceWith(replacement);
          }
        }
      }
    } catch (error) {
      // Native aborted selections are expected; report other failures.
      if (error?.name !== 'AbortError') console.warn('Zamoori context update failed', error);
    }
  });
})();